import React, { useContext } from 'react'
import AuthContext from '../../context/auth/authContext'
import GoBack from './GoBack';
import SubmitForm from './SubmitForm'

import {
EmailShareButton,
FacebookShareButton,
LinkedinShareButton,
// TwitterShareButton,
} from "react-share";
import {
EmailIcon,
FacebookIcon,
LinkedinIcon,
TwitterIcon,
} from "react-share";

function Step12() {

const authContext = useContext(AuthContext);
let { getContract, step, goBack } = authContext;

const handleSubmit = (event) => {
event.preventDefault();
// gotoNextStep([], step);

}
const title = 'Just Setup my application with CoCard!';

{/* <TwitterShareButton url="https://www.Twitter.com/cocardbusiness/" className="twitter" title={title}>
    <TwitterIcon size={20} round /> Twitter
</TwitterShareButton> */}
return (
<div className="container">
    <div className="social-buttons">
        
            <div className="item">
                <FacebookShareButton url="https://www.facebook.com/cocardpayments/​" className="facebook" quote={title}>
                    <FacebookIcon size={20} round /> Facebook
                </FacebookShareButton>
            </div>

            <div className="item">
                <LinkedinShareButton url="https://www.linkedin.com/company/cocard" title="CoCard" source="https://www.cocardpayments.com" className="linkedin">
                    <LinkedinIcon size={20} round /> LinkedIn
                </LinkedinShareButton>
            </div>

            <div className="item">
                <EmailShareButton subject="Pay 0% For Credit Card Processing" body={'link here'} url={'https://www.cocardpayments.com'} className="email" separator=" - ">
                    <EmailIcon size={20} round /> Email
                </EmailShareButton>
            </div>
            <div className="item d-block d-md-none">
                <a href="sms:&body=Pay 0% For Credit Card Processing https://www.cocardpayments.com" className="sms_text"><i className="fas fa-sms"></i> Text</a>
            </div>
    </div>
    <div className="row justify-content-center">
        <div className="col-md-5">
        {/* <GoBack goBack={goBack} step={step} /> */}

        </div>
    </div>
</div>

)
}

export default Step12
